import React from "react"
import { Box, Flex, FlexProps, Text } from "@chakra-ui/react"
import colors from "@constants/colors"
import animations from "@constants/animations"

export interface MenuItemRadioProps extends Omit<FlexProps, "children"> {
  label: string
  selected: boolean
  onClick: () => void
}

const MenuItemRadio: React.FC<MenuItemRadioProps> = ({
  label,
  selected,
  onClick,
}) => {
  return (
    <Flex
      as="button"
      onClick={onClick}
      alignItems="center"
      justifyContent="flex-start"
      w="100%"
      m="8px 0"
      p="0"
      border="none"
      bgColor="transparent"
      _hover={{ cursor: selected ? "initial" : "pointer" }}
    >
      <Flex
        alignItems="center"
        justifyContent="center"
        w="22px"
        h="22px"
        border={`solid 1px ${selected ? colors.dark : colors.midLight}`}
        borderRadius="50%"
      >
        <Box
          transition={`background-color 100ms ${animations.bezier}`}
          w="12px"
          h="12px"
          border="solid 1px transparent"
          borderRadius="50%"
          bgColor={selected ? colors.dark : colors.white}
        />
      </Flex>
      <Text
        as="span"
        pl="8px"
        fontFamily="Avenir"
        fontSize="16px"
        fontWeight="500"
        lineHeight="22px"
        fontStyle="normal"
        letterSpacing="0em"
        textAlign="left"
        color={selected ? colors.dark : colors.midAccessible}
      >
        {label}
      </Text>
    </Flex>
  )
}

export default MenuItemRadio
